<template>
    <figure
        class="flex w-full max-w-xl justify-between gap-3 md:gap-4 xl:mx-auto xl:max-w-3xl"
    >
        <template v-if="step === 1">
            <!-- Has no stepper -->
        </template>

        <!-- Start of "Osnovni podatki" -->
        <template v-if="(step >= 2) & (step <= 14)">
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green-25"
                >
                    <template v-if="step === 3">
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 4">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 5">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 6">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 7">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 8">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 9">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 10">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 11">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 12">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 13">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 14">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                    </template>
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Osnovni podatki</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        2
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Dodatni podatki</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        3
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Opis in slike</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        4
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Predogled oglasa</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Osnovni podatki" -->

        <!-- Start of "Dodatni podatki" -->
        <template v-if="(step >= 15) & (step <= 25)">
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Osnovni podatki</label
                    >
                </div>
            </div>
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green-25"
                >
                    <template v-if="step === 15">
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 16">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 17">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 18">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 19">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 20">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 21">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 22">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 23">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 24">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 25">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                    </template>
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        2
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Dodatni podatki</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        3
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Opis in slike</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        4
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Predogled oglasa</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Dodatni podatki" -->

        <!-- Start of "Opis in slike" -->
        <template v-if="(step >= 26) & (step <= 30)">
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Osnovni podatki</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        2
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Dodatni podatki</label
                    >
                </div>
            </div>
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green-25"
                >
                    <template v-if="step === 26">
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 27">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 28">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 29">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 30">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                    </template>
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        3
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Opis in slike</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        4
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Predogled oglasa</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Opis in slike" -->

        <!-- Start of "Predogled oglasa" -->
        <template v-if="(step >= 31) & (step <= 31)">
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Osnovni podatki</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        2
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Dodatni podatki</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        3
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Opis in slike</label
                    >
                </div>
            </div>
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green-25"
                >
                    <template v-if="step === 31">
                        <div class="h-[6px] w-full rounded-full bg-green"></div>
                    </template>
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        4
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Predogled oglasa</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Predogled oglasa" -->
    </figure>
</template>

<script>
export default {
    props: {
        step: {
            type: Number,
            default: 0,
        },
    },
    mounted() {
        //console.log(this.step)
    }
};
</script>
